<template>
  <details-sheet :item="requestVacation" :headers="headers" v-bind="$attrs">
    <template v-slot:item.employee_id="{ item }">
      <span>{{ item.full_name }}</span>
      <v-btn v-if="item.employee_id" class="float-right" small icon :to="to">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | dateFormat }}
    </template>
    <template v-slot:item.additional_info="{ item }">
      <v-textarea v-model="item.additional_info" outlined readonly></v-textarea>
    </template>
    <template v-slot:item.approved_days_per_year="{ item }">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                {{ $t('ITEM.YEAR') }}
              </th>
              <th class="text-left">
                {{ $t('REQUEST_VACATIONS.QUANTITY_DAYS') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="el in item.approved_days_per_year" :key="el.name">
              <td>{{ el.year }}</td>
              <td>{{ el.days }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </details-sheet>
</template>

<script>
import DetailsSheet from '@/modules/_global/_components/DetailsSheet.vue';
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'RequestVacationDetail',

  components: {
    DetailsSheet
  },

  filters: {
    dateFormat
  },

  props: {
    requestVacation: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('EMPLOYEES.ITEM'),
          value: 'employee_id'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type.name'
        },
        {
          text: this.$t('REQUEST_VACATIONS.CURR_YEAR_DAYS'),
          value: 'approved_days_per_year'
        },
        {
          text: this.$t('REQUEST_VACATIONS.DATE_OF_REQUEST'),
          value: 'created_at'
        },
        {
          text: this.$t('ITEM.DATE_FROM'),
          value: 'date_from'
        },
        {
          text: this.$t('ITEM.DATE_TO'),
          value: 'date_to'
        },
        {
          text: this.$t('HOLIDAY.ITEMS'),
          value: 'national_holidays',
          custom: (item) => (item.national_holidays || []).join(', ')
        },
        {
          text: this.$t('REQUEST_VACATIONS.REQUESTED_WORKING_DAYS'),
          value: 'quantity_days'
        },
        {
          text: this.$t('PROFILE.ADDITIONAL_INFO'),
          value: 'additional_info'
        }
      ];
    },

    name() {
      if (!this.requestVacation.person) {
        return '';
      }

      const { first_name = '', last_name = '' } = this.requestVacation.person;

      return `${first_name} ${last_name}`.trim();
    },

    address() {
      if (
        !this.requestVacation.person ||
        !this.requestVacation.person.personal_profile
      ) {
        return '';
      }

      const street = this.requestVacation.person.personal_profile.street || '';
      const zip = this.requestVacation.person.personal_profile.zip || '';
      const city = this.requestVacation.person.personal_profile.city || '';

      return `${street}, ${zip} ${city}`.replace(/^[\s,]+|[\s,]+$/g, '');
    },

    to() {
      return {
        name: 'employees.show',
        params: { id: this.requestVacation.employee_id }
      };
    }
  }
};
</script>
